/**
 * Converts a file to a base64-encoded string
 *
 * SO thread: https://stackoverflow.com/questions/13538832/convert-pdf-to-a-base64-encoded-string-in-javascript
 */
export const convertFileToBase64 = async (file: File): Promise<string> => {
  return new Promise(res => {
    const fileReader = new FileReader();

    let base64;
    fileReader.onload = function (fileLoadedEvent) {
      base64 = fileLoadedEvent?.target?.result;
      // Remove corrupting leading declaration
      res(base64.replace("data:application/pdf;base64,", ""));
    };

    fileReader.readAsDataURL(file);
  });
};
